export function checkFeaturePermission(isPermissionEnabled: boolean, hasPermission: boolean): boolean {
  return isPermissionEnabled ? hasPermission : true;
}
